import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import {
  getActiveBannerNotificationURL,
  getBannerNotificationURL,
  getDeleteBannerNotificationURL
} from "../utils/constants/apiEndPoints";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { bannerNotiText, commonErrMsg } from "../locales/en";

// Initial state
const initialState = {
  loading: false,
  notificationData: [],
  error: null
};

// Slice
const bannerNotificationSlice = createSlice({
  name: "bannerNotification",
  initialState,
  reducers: {
    setNotificationData(state, action) {
      state.notificationData = action.payload;
    },
    setNotificationLoading(state, action) {
      state.loading = action.payload;
    },
    setNotificationError(state, action) {
      state.error = action.payload;
    }
  }
});

// Thunk: fetch notifications
export const getBnrNotification = createAsyncThunk(
  "bannerNotification/getBnrNotification",
  async (payload, { dispatch }) => {
    try {
      dispatch(setNotificationLoading(true));
      const response = await privateAxios.get(getBannerNotificationURL, {
        params: payload
      });
      return response;
    } finally {
      dispatch(setNotificationLoading(false));
    }
  }
);

// Thunk: fetch the active banner(s) to display to the current user
export const getActiveBnrNotification = createAsyncThunk(
  "bannerNotification/getActiveBnrNotification",
  async (_, { dispatch }) => {
    try {
      dispatch(setNotificationLoading(true));
      const response = await privateAxios.get(getActiveBannerNotificationURL);
      return response;
    } finally {
      dispatch(setNotificationLoading(false));
    }
  }
);

// Thunk: delete notification
export const deleteBnrNotificationThunk = createAsyncThunk(
  "bannerNotification/deleteBnrNotificationThunk",
  async (payload, { dispatch }) => {
    try {
      dispatch(setNotificationLoading(true));
      const response = await privateAxios.patch(
        getDeleteBannerNotificationURL(payload)
      );

      if (response.status === 200) {
        showToast(bannerNotiText?.table.errMsg.item4, showToastType.success);
        return response;
      }
    } catch (error) {
      error?.response?.data?.message || error.message || commonErrMsg.item7;
    } finally {
      dispatch(setNotificationLoading(false));
    }
  }
);

// Actions & Reducer export
export const {
  setNotificationData,
  setNotificationLoading,
  setNotificationError
} = bannerNotificationSlice.actions;

export default bannerNotificationSlice.reducer;
